import { TestimonialMarquee, type Proof } from './TestimonialMarquee';
import styles from './split.module.css';

/**
 * Left 60% of the shell — three zones pushed apart.
 *   header   brand + one headline
 *   centre   what Velora is, at a glance
 *   footer   testimonials, edge to edge, looping
 */
export function ShowcasePanel() {
  return (
    <aside className={styles.panel} aria-label="About Velora">
      <div className={styles.panelInner}>
        <header className={styles.header}>
          <div className={styles.brand}>
            <div className={styles.brandMark}>V</div>
            <span className={styles.wordmark}>Velora</span>
          </div>
          <h1 className={styles.headline}>
            Every register in one place. <span className={styles.headlineAccent}>Every guardian too.</span>
          </h1>
        </header>

        <div className={styles.scene}>
          <div className={styles.sceneLabel}>What comes with Velora</div>
          <div className={styles.tiles}>
            <Tile head="blue" name="Attendance" sub="Ten seconds, from the corridor" />
            <Tile head="purple" name="Marks & report cards" sub="Entered once. Everywhere at once." />
            <Tile head="gold" name="Fees & receipts" sub="Append-only. March-defensible." />
            <Tile head="green" name="Guardian app" sub="One notification per family. Not six." />
          </div>
        </div>
      </div>

      <TestimonialMarquee items={PROOF} />
    </aside>
  );
}

function Tile({ head, name, sub }: { head: 'blue' | 'purple' | 'gold' | 'green'; name: string; sub: string }) {
  const headClass =
    head === 'blue' ? styles.tileHeadBlue :
    head === 'purple' ? styles.tileHeadPurple :
    head === 'gold' ? styles.tileHeadGold :
    styles.tileHeadGreen;
  return (
    <div className={styles.tile}>
      <div className={`${styles.tileHead} ${headClass}`} />
      <div className={styles.tileName}>{name}</div>
      <div className={styles.tileSub}>{sub}</div>
    </div>
  );
}

const PROOF: Proof[] = [
  {
    id: 'p1',
    rating: 5,
    source: 'principal',
    quote: 'March defensibility, finally. The audit log ends the argument before it starts.',
    initials: 'RD',
    name: 'R. Deshmukh',
    role: 'Principal, Greenwood Senior',
  },
  {
    id: 'p2',
    rating: 5,
    source: 'trustee',
    quote: 'Two weeks to onboard a school. An afternoon to add a college.',
    initials: 'AK',
    name: 'A. Kulkarni',
    role: 'Trustee, Sahyadri Group',
  },
  {
    id: 'p3',
    rating: 5,
    source: 'guardian',
    quote: 'One notification for two children, not six. My family thanks you.',
    initials: 'SB',
    name: 'S. Bhosale',
    role: 'Guardian, Class 9 & 6',
  },
  {
    id: 'p4',
    rating: 4,
    source: 'teacher',
    quote: "Attendance in ten seconds, on the third floor with no signal. It's the reason I still open it.",
    initials: 'KK',
    name: 'K. Kaur',
    role: 'Teacher, English',
  },
  {
    id: 'p5',
    rating: 5,
    source: 'support',
    quote: 'SMS delivery to one operator dropped and we called the schools before they called us.',
    initials: 'DK',
    name: 'D. Kulkarni',
    role: 'Engineering, Velora',
  },
];
